'use client'

/**
 * DeferredAnalytics
 *
 * Renders Google Analytics + GTM after idle so they do not block LCP/TBT.
 * Product analytics is PostHog (separate provider). Vercel Analytics removed.
 */

import { useEffect, useState } from 'react'
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google'

const GA_ID = 'G-Y6QQ640Z91'
const GTM_ID = 'GTM-W96WXZDG'

export function DeferredAnalytics() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    let id: number
    if (typeof requestIdleCallback !== 'undefined') {
      id = requestIdleCallback(() => setMounted(true), { timeout: 4500 })
      return () => cancelIdleCallback(id)
    }
    id = window.setTimeout(() => setMounted(true), 3500)
    return () => window.clearTimeout(id)
  }, [])

  if (!mounted) return null

  return (
    <>
      <GoogleAnalytics gaId={GA_ID} />
      <GoogleTagManager gtmId={GTM_ID} />
    </>
  )
}
